<template>

    <v-app id="inspire">
        <v-layout row justify-center>
            <v-dialog v-model="onShow" persistent max-width="40%">
                <v-card>
                    <v-card-title>
                        <span class="subheading">MARS - Role administration: {{ role.name }}</span>
                    </v-card-title>

                    <v-divider></v-divider>

                    <v-container grid-list-xs style="overflow-y: auto; margin-top: -20px">
                        <v-layout wrap>
                            <v-flex class="modal-flex-height" xs12 sm5>
                                <v-subheader>Name</v-subheader>
                            </v-flex>

                            <v-flex class="modal-flex-height compact-form" xs12 sm7>
                                <v-text-field
                                        id="modify_role_name_field"
                                        v-model="role.name"
                                        name="name"
                                        color="grey darken-2"
                                        :disabled="disabled"
                                        class="text-xs-left"
                                        v-validate="'required:true'"
                                        :error-messages="errors.first('name')"
                                ></v-text-field>
                            </v-flex>


                            <v-flex class="modal-flex-height" xs12 sm5>
                                <v-subheader>Description</v-subheader>
                            </v-flex>

                            <v-flex class="modal-flex-height compact-form" xs12 sm7>
                                <v-text-field
                                        id="modify_role_description_field"
                                        v-model="role.description"
                                        name="description"
                                        color="grey darken-2"
                                        :disabled="disabled"
                                        class="text-xs-left"
                                ></v-text-field>
                            </v-flex>

                            <v-flex class="modal-flex-height" xs12 sm5>
                                <v-subheader>Hierarchy</v-subheader>
                            </v-flex>

                            <v-flex class="modal-flex-height compact-form" xs12 sm7>
                                <v-text-field
                                        id="modify_role_hierarchy_field"
                                        v-model="role.hierarchy"
                                        name="hierarchy"
                                        color="grey darken-2"
                                        :disabled="disabled"
                                        class="text-xs-left"
                                        v-validate="'integer:true|required:true|min_value:2'"
                                        :error-messages="errors.first('hierarchy')"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>

                    <v-alert :value="error" type="error" transition="scale-transition">
                        {{ errorMessage }}
                    </v-alert>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn id="modify_role_save_button" class="text-none" color="green" small dark @click="onSaveRole"
                               :disabled="disabled">
                            Save
                        </v-btn>
                        <v-btn id="modify_role_cancel_button" class="text-none" small @click="close">Cancel</v-btn>
                    </v-card-actions>

                </v-card>
            </v-dialog>
        </v-layout>
    </v-app>
</template>

<script>

    import roleinterface from "../../../../interfaces/roleinterface";
    import {EventBus} from "../../../../eventbus";
    import errormessagemanager from "../../../../managers/errormessagemanager";


    export default {
        name: 'ShowRoleModal',
        props: {
            value: Boolean,

            editMode: Boolean,
            disabled: Boolean,
            role: {
                roleId: Number,
                name: String,
                description: String,
                roleAppRights: Array,
                rolePoolGroupRights: Array
            }
        },

        data: () => ({
            error: false,
            errorMessage: null
        }),


        computed: {
            getTitle: function () {
                return this.editMode ? "Edit" : "Create";
            },

            onShow: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        },

        methods: {

            async onSaveRole() {
                this.clearAlert();

                this.$validator.validateAll().then(async result => {
                    if (result) {
                        let response = null;

                        if (!this.editMode) {
                            await roleinterface.postRole(this.role, res => {
                                response = res;
                            });
                        } else {
                            await roleinterface.putRole(this.role, res => {
                                response = res;
                            });
                        }

                        if (response != null && response.error) {
                            if (!this.editMode) {
                                errormessagemanager.getInsertErrorMessage(response.status, message => {
                                    this.errorMessage = message;
                                });
                                this.error = response.error;
                            } else {
                                errormessagemanager.getUpdateErrorMessage(response.status, message => {
                                    this.errorMessage = message;
                                });
                                this.error = response.error;
                            }
                        } else if (!this.error) {
                            await EventBus.$emit('refreshRoleList');
                            await this.close();
                        }
                    }
                });
            },
            
            async close() {
                await this.$emit('roleModalClosed');
                this.onShow = false;

                this.clearData();
                this.clearAlert();
            },

            clearData() {
                this.role.roleId = null;
                this.role.name = null;
                this.role.description = null;
                
                this.$validator.errors.clear();
                this.$validator.fields.items.forEach(field => field.reset());
                this.$validator.fields.items.forEach(field => this.errors.remove(field));
                this.$validator.resume();
            },

            clearAlert() {
                this.error = false;
                this.errorMessage = null;
            }
        }
    }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/roles/modals/ShowRoleModal.vue